import React from "react";
import { Outlet } from "react-router-dom";
import { FloatButton, Layout } from 'antd';
import { mdiArrowUpBold } from "@mdi/js";
import Icon from "@mdi/react";
import Header from "./Header";
import Footer from "./Footer";

const { Content } = Layout;

const MainLayout = () => {
  return (
    <Layout>
      <Header/>
      <Content>
        <Outlet/>
        <FloatButton.BackTop icon={<Icon path={mdiArrowUpBold} size="32px" />}/>
      </Content>
      <Footer/>
    </Layout>
  )
};

export default MainLayout;